export enum EmergencyPlanActionType {
    Note = 'note',
    CallPhone = 'call phone',
    LocalLink = 'local link',
    GlobalLink = 'global link',
}
